import { useFormContext } from 'react-hook-form';

import type { CompanyFormSchema } from '../schemas';

export const useCompanyFormContext = () => {
  const context = useFormContext<CompanyFormSchema>();
  return context;
};
